import reports from './../../../services/sales/reports'

export default {
    namespaced: true,
    state: {
        data: [],
        params: {
            type: "",
            min_amount: null,
            date: null
        },
        loading: false
    },
    getters: {
        data: state => state.data,
        params: state => state.params,
        loading: state => state.loading,
    },
    mutations: {
        data: (state, payload) => state.data = payload,
        params: (state, payload) => state.params = payload,
        loading: (state, payload) => state.loading = payload,
    },
    actions: {
        get(context) {
            return new Promise((resolve, reject) => {
                context.commit("loading", true);
                reports.customersBalance(context.state.params)
                    .then(response => {
                        context.commit("data", response.data);
                        resolve(response);
                    })
                    .catch(error => reject(error))
                    .finally(() => context.commit("loading", false));
            });
        },
        updateParams(context, payload) {
            context.commit("params", payload);
            return new Promise((resolve, reject) => {
                context.dispatch("get").then(response => resolve(response)).catch(error => reject(error));
            });
        }
    }
}